import { render } from "./PwaInstallPrompt.vue?vue&type=template&id=e563498c&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"

import "./PwaInstallPrompt.vue?vue&type=style&index=0&id=e563498c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e563498c"]])

export default __exports__